import React from 'react';
import { HighlightElement } from '../../types/arGuides';

interface PulsingHighlightProps {
  highlight: HighlightElement;
}

export const PulsingHighlight: React.FC<PulsingHighlightProps> = ({ highlight }) => {
  const { position, shape, animation, infinite = false } = highlight;

  // Validar que position exista y tenga dimensiones válidas
  if (!position || !position.width || !position.height || position.width <= 0 || position.height <= 0) {
    return null;
  }

  const animationClass = animation === 'pulse' ? 'animate-pulse' : 'animate-glow';
  const infiniteClass = infinite ? 'infinite' : '';

  if (shape === 'circle') {
    const radius = Math.max(position.width, position.height) / 2 + 10;
    const cx = position.x + position.width / 2;
    const cy = position.y + position.height / 2;

    return (
      <circle
        cx={cx}
        cy={cy}
        r={radius}
        stroke="var(--cm-trigo)"
        strokeWidth="4"
        fill="none"
        className={`${animationClass} ${infiniteClass}`}
        opacity="0.8"
      />
    );
  }

  return (
    <rect
      x={position.x - 5}
      y={position.y - 5}
      width={position.width + 10}
      height={position.height + 10}
      stroke="var(--cm-trigo)"
      strokeWidth="4"
      fill="none"
      rx="8"
      className={`${animationClass} ${infiniteClass}`}
      opacity="0.8"
    />
  );
};
